<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'leiloeiro',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      }
    }
  }
</script>

<template>
    <div>
        <div class="app-content-body ">
            <div class="bg-light lter b-b wrapper-md">
              <h1 class="m-n font-thin h3">Leiloeiro</h1>
            </div>
            <div class="wrapper-md">
              <div class="panel panel-default">
                <div>
                  <table class="table" ui-jq="footable" ui-options='{
                    "paging": {
                      "enabled": true
                    },
                    "filtering": {
                      "enabled": true
                    },
                    "sorting": {
                      "enabled": true
                    }}'>
                    <thead>
                    <tr class="footable-filtering">
                            <th colspan="6">
                                <form class="form-inline">
                                    <div class="form-group">
                                        <label class="sr-only">Search</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="Search">
                                            <div class="input-group-btn">
                                                <button type="button" class="btn btn-primary">
                                                    <span class="fa fa-search"></span>
                                                </button>
                                                <button type="button" class="btn btn-default dropdown-toggle">
                                                    <span class="caret"></span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">ID
                                                            </label>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">First Name
                                                            </label>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">Last Name
                                                            </label>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">Job Title
                                                            </label>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">Started On
                                                            </label>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked="checked">DOB
                                                            </label>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </th>
                        </tr>
                        <tr>
                            <th data-breakpoints="xs">ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th data-breakpoints="xs">Job Title</th>
                            <th data-breakpoints="xs sm">Started On</th>
                            <th data-breakpoints="xs sm md" data-title="DOB">Date of Birth</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr data-expanded="true">
                        <td>1</td>
                        <td>Dennise</td>
                        <td>Fuhrman</td>
                        <td>High School History Teacher</td>
                        <td>November 8th 2011</td>
                        <td>July 25th 1960</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Elodia</td>
                        <td>Weisz</td>
                        <td>Wallpaperer Helper</td>
                        <td>October 15th 2010</td>
                        <td>March 30th 1982</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Raeann</td>
                        <td>Haner</td>
                        <td>Internal Medicine Nurse Practitioner</td>
                        <td>November 28th 2013</td>
                        <td>February 26th 1966</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Junie</td>
                        <td>Landa</td>
                        <td>Offbearer</td>
                        <td>October 31st 2010</td>
                        <td>March 29th 1966</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Solomon</td>
                        <td>Bittinger</td>
                        <td>Roller Skater</td>
                        <td>December 29th 2011</td>
                        <td>September 22nd 1964</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Leiloeiro.vue?df5044d6